import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OnlineHeader } from './style';
import { OnlineCall, RecentCall, CallScreen } from '../layout';
import { connect } from 'react-redux';
import { globalStateSelector } from '../../../store/selector';
export class Online extends Component {
  renderRecentCall() {
    return (
      <React.Fragment>
        <OnlineHeader>
          <h6 className="mb-0 fontClass">Recent Calls</h6>
        </OnlineHeader>
        <RecentCall />
        <OnlineCall />
      </React.Fragment>
    );
  }
  renderOnCall() {
    return (
      <React.Fragment>
        <CallScreen />
      </React.Fragment>
    );
  }
  render() {
    const { onCall } = this.props;
    return (
      <React.Fragment>
        {onCall ? this.renderOnCall() : this.renderRecentCall()}
      </React.Fragment>
    );
  }
}

Online.propTypes = {
  onCall: PropTypes.bool
};
const stateToProps = state => ({
  onCall: globalStateSelector.getOnCall(state)
});

const dispatchToProps = dispatch => ({
  receiveSocketMessage: data => {
    // dispatch(messageAction.receiveSocketMessage(data));
  }
});

export default connect(stateToProps, dispatchToProps)(Online);



// WEBPACK FOOTER //
// src/dialpad/components/layout/Online.js